module.exports = __webpack_public_path__ + "static/media/motorencapsulado6.352df030.jpg";